<div  [@routerTransition]>
  <div class="job-posts placements agreements">
    <div class="card skillassest-form margin-top-6px">
 
      <div class="card-body padding-top">
 
     
            <div class="card card-height-2">
        
              <div class="card-body padding-top padding-left-4 padding-right-9px">
                <div class="row row-margin-zero row-line-height border-bottom rowfor" *ngFor="let l of pdata;let RowIndex = index">
                  <div class="col-md-2 col2 border-right padding-ln-5px col-2">
                    <div class="row margin-lr-auto">
                      <label class="label6 normal-text-5"> {{l.JoinByDate | date: 'EEE'}}</label>

                      <div class="row">
                        <div class="offset-md-1 col-md-4 col-4">
                          <label class="label3 margin-left-5px margin-top-0px">{{l.JoinByDate | date: 'dd'}}</label>
                        </div>
                        <div class="col-md-4 padding-left-10px col-4">
                          <label class="label6 normal-text-5 "> {{l.JoinByDate | date: 'MMM'}}</label>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-10 padding-lr col-10">

                    <div class="card">
                      <div class="card-body padding-lrt">
                        <div class="row margin-left-zero margin-right-0px">
                          <div class="col-md-10 padding-right-0px padding-left-9px col-10">
                            <div class="row margin-left-zero">
                              <label class="normal-small-text"><label class="normal-small-text2"> {{l. HospitalDisplayName}} </label></label>

                            </div>
                            <div class="row margin-left-zero">
                              <div class="margin-top">
                                <label class="normal-small-text"> {{l. HospitalState}}</label>
                              </div>

                            </div>
                          </div>
                         
                          <div class="col-md-2  col-2 margin-all padding-right-0px padding-l-0px text-align-center">
                            <div>
                              <label class="normal8 margin-bottom-0px font-weight-600">${{l.ProposedCopmpensation}}</label>
                            </div>
                          </div>

                          <!--<div class="col-md-3 margin-all font-size-14px display-col" hidden>
                            
                            <div [ngSwitch]="l.ApplicationStatus">

                          
                              <a  data-toggle="tooltip" data-placement="bottom" title="{{l.ApplicationStatus}}">
                                <i *ngSwitchCase="'Shift Request'"
                                   class="fas fa-long-arrow-alt-down color-Forwarded nav-link-hand font-size-14">
                                </i>
                              </a>

                              <a data-toggle="tooltip" data-placement="bottom" title="{{l.ApplicationStatus}}">
                                <i *ngSwitchCase="'Offer Released'"
                                   class="fas fa-certificate color-default nav-link-hand font-size-14">
                                </i>
                              </a>
                          
                              <a  data-toggle="tooltip" data-placement="bottom" title="{{l.ApplicationStatus}}">
                                <i *ngSwitchCase="'Accepted'"
                                   class="fas fa-circle color-default nav-link-hand font-size-14">
                                </i>
                              </a>
                              <a  data-toggle="tooltip" data-placement="bottom" title="{{l.ApplicationStatus}}">
                                <i *ngSwitchCase="'Forwarded'"
                                   class="fas fa-arrow-alt-circle-right color-Forwarded nav-link-hand font-size-18px">
                                </i>
                              </a>
                              <a  data-toggle="tooltip" data-placement="bottom" title="{{l.ApplicationStatus}}">
                                <i *ngSwitchCase="'Rejected'"
                                   class="fas fa-circle color-Rejected nav-link-hand font-size-14">
                                </i>
                              </a>
                              <a  data-toggle="tooltip" data-placement="bottom" title="{{l.ApplicationStatus}}">
                                <i *ngSwitchCase="'Pinned'"
                                   class="fas fa-map-pin color-Forwarded  nav-link-hand font-size-14">
                                </i>
                              </a>
                              <a  data-toggle="tooltip" data-placement="bottom" title="{{l.ApplicationStatus}}" class="badge badge-Applied">
                                <i *ngSwitchCase="'Assigned'"
                                   class="nav-link-hand font-size-14 color-Forwarded font-style-initial">
                                  A
                                </i>
                              </a>



                              <a  data-toggle="tooltip" data-placement="bottom" title="{{l.ApplicationStatus}}">
                                <i *ngSwitchDefault
                                   class="fas fa-circle color-default nav-link-hand font-size-14">

                                </i>
                              </a>
                            </div>
                          
                          </div>-->
                         


                        </div>
                        <div class="row margin-left-zero">
                          <div class="col-md-12 col-12 padding-left-9px">
                            <label class="margin-bottom-0px font-size-12px">
                              {{GetShiftStatus(l)}}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
        

                        <!--<div class="table-component">
                          <div class="table-responsive overflow-x">
                          
                            <table class="table table-striped margin-left-5px"

                                   cols="auto,2*,*,*,*,*,*,*,*,*">
                            
                              <thead class="">
                                <tr>
                                  <th class="text-align-center">Date</th>
                         
                                  <th class="text-align-center">Hospital</th>
                                  <th scope="col" class="text-align-center">Shift</th>
                    
                                  <th scope="col" class="text-align-center">Pay Rate</th>
                                  <th scope="col" class="text-align-center">Status</th>
                                  <th scope="col"></th>
                              



                                </tr>
                              </thead>

                              <tbody class="table-body">
                               
                                <tr *ngFor="let l of pdata;let RowIndex = index">
                                  <td class="td-width td-padding border-right background-2">
                                    <div>
                                      {{l.JoinByDate | date: 'EEE'}}
                                    </div>
                                    <div class="text-align-center">
                                      <label class="margin-bottom-0px font-size-16px">  {{l.JoinByDate | date: 'dd'}}</label>
                                      {{l.JoinByDate | date: 'MMM'}}
                                    </div>

                                  </td>


                        
                                  <td class=" td-padding text-align-center">
                                    {{l. HospitalDisplayName}}
                                    <br />{{l. HospitalState}}
                                  </td>
                                  <td class=" td-padding text-align-center">{{l.ShiftType}}</td>
                                 
                                  <td class=" td-padding text-align-center">{{l.ProposedCopmpensation}}</td>
                                  <td class=" td-padding text-align-center">{{l.ApplicationStatus}}</td>
                                  <td class=" td-padding text-align-center">
                                    <div class="thick-circle4 nav-link-hand">
                                      <a (click)="openScheduleAssistant()">
                                        <i class="fas fa-ellipsis-h"></i>
                                      </a>
                                    </div>
                                  </td>

                   
                                </tr>

                              </tbody>
                            </table>
                          </div>
                        </div>-->
                    
              </div>
            </div>
 
        </div>
      </div>
      </div>
      </div>



